import { useState, useEffect, useCallback } from 'react';

const MIN_PC_WIDTH = 1024;

export const useWindowWidth = () => {
  const [width, setWidth] = useState(window.innerWidth);

  const handleResize = useCallback(() => {
    setWidth(window.innerWidth);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize]);

  return { width, isPC: width >= MIN_PC_WIDTH };
};
